module.exports = function() {

  /**
   *  Validates an array.
   *
   *  @param cb The callback function.
   */
  this.main.array = function array(cb) {
    if(this.validates()) {
      this.required();
      this.type();
      this.range();
    }
    cb();
  }

}



//////////////////
// WEBPACK FOOTER
// ../node_modules/async-validate/plugin/array.js
// module id = 1369
// module chunks = 93